module.exports = __webpack_public_path__ + "media/images/hearing_icon-e0612ebcd49034bdc6779d19ddc37dd4.png";